import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface PlayerState {
  isVisible: boolean;
  songUrl: string | null;
  id: string | number | null;
  track_name: string;
  track_artist: string;
  isPlaying: boolean;
}

const initialState: PlayerState = {
  isVisible: false,
  songUrl: null,
  track_name: '',
  track_artist: '',
  id: 0,
  isPlaying: false,
};

const playerSlice = createSlice({
  name: 'player',
  initialState,
  reducers: {
    playSong: (
      state,
      action: PayloadAction<{
        songUrl: string;
        id: number | string;
        track_name: string;
        track_artist: string;
      }>,
    ) => {
      state.songUrl = action.payload.songUrl;
      state.id = action.payload.id;
      state.track_name = action.payload.track_name;
      state.track_artist = action.payload.track_artist;
      state.isVisible = true;
      state.isPlaying = true;
    },
    playPlayer: state => {
      state.isPlaying = true; // Toggle playback state
      state.isVisible = true;
    },
    pausePlayer: state => {
      state.isPlaying = false;
    },
    closePlayer: _state => {
      return initialState;
    },
    togglePlayerState: state => {
      state.isPlaying = !state.isPlaying;
    },
  },
});

export const {
  playSong,
  closePlayer,
  playPlayer,
  pausePlayer,
  togglePlayerState,
} = playerSlice.actions;
export default playerSlice.reducer;
